"use client";

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MixerHorizontalIcon } from "@radix-ui/react-icons";
import { useFilter } from "@/hooks/use-filter";
import { useStore } from "zustand";
import { Button } from "@/components/ui/button";
import { Combobox } from "@/components/ui/combo-box";
import type { Filter } from "@/types/script";

export default function FilterDropdown() {
  const filter = useStore(useFilter, (state) => state);
  const filters = filter.filters;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary">
          <MixerHorizontalIcon className="mr-2 size-4" /> Filter
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64 border-input bg-background/90 p-2 backdrop-blur">
        <DropdownMenuLabel>Sort by</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuCheckboxItem
          checked={filters.payment === "Free"}
          onCheckedChange={(checked) =>
            filter.setFilters({ payment: checked ? "Free" : undefined })
          }
        >
          Free
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={filters.payment === "Paid"}
          onCheckedChange={(checked) =>
            filter.setFilters({ payment: checked ? "Paid" : undefined })
          }
        >
          Paid
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          disabled={filters.payment === "Paid"}
          checked={filters.key_system}
          onCheckedChange={(checked) =>
            filter.setFilters({ key_system: checked })
          }
        >
          Key System
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={filters.mobile}
          onCheckedChange={(checked) => filter.setFilters({ mobile: checked })}
        >
          Mobile Support
        </DropdownMenuCheckboxItem>
        <DropdownMenuSeparator />

        <Combobox
          mode="single"
          options={[
            { value: "Upload Date", label: "Upload Date" },
            { value: "Rating", label: "Rating" },
          ]}
          placeholder="Select option..."
          selected={filters.sortBy as string}
          onChange={(value) =>
            filter.setFilters({ sortBy: value as Filter["sortBy"] })
          }
        />
        <Combobox
          className="mt-0.5"
          mode="single"
          options={[
            { value: "asc", label: "Ascending" },
            { value: "desc", label: "Descending" },
          ]}
          placeholder="Select option..."
          selected={filters.orderBy as string}
          onChange={(value) =>
            filter.setFilters({ orderBy: value as Filter["orderBy"] })
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
